import { getTextFromHtml, HoverCardProps, slugify, useWindowWidth } from '@prishapolicy/shared/ui';
import { SSRHoverCard } from '@prishapolicy/w3/ui';

export const ProtectToday = ({
  items = [],
  maxPerRow = 4,
  productCategoryPrefix,
}: {
  items: HoverCardProps[];
  maxPerRow?: number;
  productCategoryPrefix: string;
}) => {
  const { isLg } = useWindowWidth();
  maxPerRow = !isLg ? 2 : maxPerRow;
  const groups = items
    .map(function (_, i) {
      return i % maxPerRow === 0 ? items.slice(i, i + maxPerRow) : [];
    })
    .filter(function (e) {
      return e;
    });

  return (
    <div className="bg-surface-grey pb-14">
      <div className="container">
        <h2 className="lg:heading-3 heading-4 py-12 text-center">What Would You Like to Protect Today?</h2>
        <div>
          {groups.map((group, idx) => {
            return (
              group.length > 0 && (
                <div
                  key={idx}
                  className={`my-4 flex flex-col gap-y-4 gap-x-4 xl:grid grid-cols-${Math.min(
                    maxPerRow,
                    group.length,
                  )}`}
                >
                  {group.map((item, idx) => {
                    return (
                      <SSRHoverCard
                        key={idx}
                        href={`/products/${productCategoryPrefix}/${slugify(getTextFromHtml(item.name))}`}
                        name={item.name}
                      />
                    );
                  })}
                </div>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProtectToday;
